"use strict";

import React from "react";
import Wprr from "wprr";

export default class ImageBackgroundArea extends Wprr.Layout {
	
	/**
	 * Constructor
	 */
	_construct() {
		super._construct();
	}
	
	_getLayout(aSlots) {

		let image = this.getFirstInput(Wprr.sourceReference("blockData", "image.url"));
		
		return <div className="image-background-area absolute-container">
			<div className="absolute-overlay">
				<div className="full-size">
					<Wprr.Image className="background-cover full-size" src={image} />
				</div>
				<div className="absolute-overlay" style={{backgroundColor: "rgba(255,255,255,0.8)"}}></div>
			</div>
			<div className="position-relative">
				<div className="spacing double" />
					{aSlots.default(React.createElement(Wprr.ContentsAndInjectedComponents, {content: Wprr.sourceReference("blockData", "innerMarkup")}))}
				<div className="spacing double" />
			</div>
		</div>;
	}
	
	static getWpAdminEditor() {
		console.log("getWpAdminEditor");
		
		let dataSettings = {
			
		};
		
		return React.createElement("div", null,
			React.createElement(Wprr.FlexRow, {className: "small-item-spacing vertically-center-items", itemClasses: "flex-resize,flex-no-resize,flex-resize"},
				React.createElement("hr", { className: "line no-margin"}),
				React.createElement("div", null, Wprr.translateText("Background area")),
				React.createElement("hr", {className: "line no-margin"})
			),
			<Wprr.layout.form.LabelledArea label="Image">
								<Wprr.wp.blocks.editor.ImageSelection valueName="image" />
							</Wprr.layout.form.LabelledArea>,
			React.createElement(wp.editor.InnerBlocks, null),
			React.createElement(Wprr.FlexRow, {className: "small-item-spacing vertically-center-items", itemClasses: "flex-resize,flex-no-resize,flex-resize"},
				React.createElement("hr", {className: "line no-margin"}),
				React.createElement("div", null, Wprr.translateText("End:"), " ", Wprr.translateText("Background area")),
				React.createElement("hr", {className: "line no-margin"})
			)
		);
	}
}